/**
 * @file        src/data/fares.js
 * @description Economy fare options shown on fare-selection screen.
 *              Ported verbatim from /Neon Bookign site Design/.
 * @author      Kinetika Labs
 * @created     2026-06-22
 * @changelog
 *   - 2026-06-22 Claude — Initial.
 */

// Economy fare options (from fare-selection screen)
export const FARES = [
  { name:'Economy class', tag:'Lowest price with checked baggage', baggage:['Carry-on baggage: 1 piece','Checked baggage: 1 × 15 kg'], flex:['Cancellation fee: from ₹5,540','Change fee: from ₹5,540'], price:8567, was:8775 },
  { name:'Economy class', baggage:['Carry-on baggage: 1 piece','Checked baggage: 1 × 15 kg'], flex:['Cancellation fee: from ₹4,330','Change fee: from ₹3,025'], price:8590, was:8707 },
  { name:'Economy class', baggage:['Carry-on baggage: 1 piece','Checked baggage: Not included'], flex:['Cancellation fee: from ₹3,025','Change fee: from ₹1,020'], price:9118, was:9357 },
];
